<template>
  <div>
     <button id="confirmationBtn" data-bs-target="#confirmation" data-bs-toggle="modal" style="display: none" />
     <div
        id="confirmation"
        aria-hidden="true"
        aria-labelledby="confirmation-data"
        class="modal fade modal-custom"
        data-backdrop="static"
        data-keyboard="false"
        role="dialog"
        tabindex="-1"
     >
        <div class="modal-dialog" role="document">
           <div class="modal-custom__content">
              <span class="modal-custom__action" data-bs-dismiss="modal" @click="onClose">
                 <i class="icon-fonts icon-fonts--close"></i>
              </span>
              <div class="modal-custom__body">
                 <div v-if="showedData.icon" class="modal-custom__images">
                    <img :src="showedData.icon" alt="img" />
                 </div>
                 <h3 class="modal-custom__title">{{ showedData.title }}</h3>
                 <p class="modal-custom__des" v-html="showedData.content"></p>
                 <div class="modal-custom__btn">
                    <button class="button" data-bs-dismiss="modal" @click="onCancel">
                       {{ showedData.cancelButton }}
                    </button>
                    <button
                       class="button primary"
                       data-bs-dismiss="modal"
                       @click="onConfirm(showedData.confirmedData)"
                    >
                       {{ showedData.confirmButton }}
                    </button>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</template>
<script>
import $ from 'jquery'
import i18n from '@/plugins/i18n'

export default {
  name: 'confirmation-modal',
  props: {
     data: Object, // Type: {title: "", content: "", cancelButton: "", confirmButton: "", confirmedData: {}},
     onConfirm: Function,
     onCancel: {
        type: Function,
        default: () => {}
     },
     onClose: {
        type: Function,
        default: () => {}
     }
  },
  data() {
     return {
        showedData: {}
     }
  },
  watch: {
     data() {
        this.showedData = {
           title: this.data.title ?? i18n.t('confirmation.title'),
           icon: this.data.icon,
           content: this.data.content,
           cancelButton: this.data.cancelButton ?? i18n.t('buttons.cancel'),
           confirmButton: this.data.confirmButton ?? i18n.t('buttons.confirm'),
           confirmedData: this.data.confirmedData
        }
        $('#confirmationBtn').trigger('click')
     }
  }
}
</script>

<style lang="scss" scoped>
.modal-custom {
  &__content {
     position: relative;
     padding: 30px 25px;
  }

  &__action {
     position: absolute;
     top: 20px;
     right: 20px;
     height: 20px;
     width: 20px;
     display: flex;
     align-items: center;
     justify-content: center;
     background: var(--bs-primary);
     border-radius: 50%;
     padding: 0;

     i {
        color: var(--bs-white);
        font-size: 15px;
        font-weight: bolder;
     }
  }

  &__title {
     font-size: 17px;
     color: #000000;
     font-weight: bold;
     margin-bottom: 10px;
  }

  &__btn {
     margin: 30px 0 0;
     gap: 20px;

     .button {
        margin: 0;
        border: 1px solid var(--bs-primary);
        color: #000000;
        font-weight: bold;
        font-size: 15px;
        border-radius: 100px;
        height: 36px;

        &.primary {
           background: var(--bs-primary);
           color: var(--bs-white);
        }
     }
  }
}
</style>
